module.exports = __webpack_public_path__ + "h5/img/close.446e8669.gif";